import { Vue,Component,Prop,Watch} from 'vue-property-decorator';
import NotificationStatusBySubscriberDetails from '../NotificationstatusbySubscriberDetails/NotificationstatusbySubscriberDetails.vue';
import NotificationByStaffModal from '../../NotificationByStaffModal/NotificationByStaffModal';
import {notificationSubscriberList,notificationStatusListBySubscriber} from '@/types/Component';

@Component({
    components: {
        NotificationStatusBySubscriberDetails,
        NotificationByStaffModal
      }
})

   
export default class NotificationStatusBySubscriberList extends Vue {


  baseUrl = "/notificationStatus";
    notificationSubscriberList :  notificationSubscriberList[]=[]
  private  notificationStatusListBySubscriber = [] as notificationStatusListBySubscriber[]
  sortByCompanyNameASC= false
  private searchText = ''
  private items : notificationSubscriberList [] =[]
  private isNotificationSubscriberModal= false;


  private subscriptionId =""
  created (){
    this.getNotficationStatusBySubscriber();
  } 

  getNotficationStatusBySubscriber(){
        this.$apiClient.doRequest('get', `${this.baseUrl}/notification_status_subscriber_list/`)
        .then((res)=>{
        this.notificationSubscriberList = res.notificationStatusSubscriberList
        this.items = this.notificationSubscriberList
        this.getSubscriptionNotificationList(res?.notificationStatusSubscriberList[0]?.tenantId,false)
        this.isActive(res?.notificationStatusSubscriberList[0]?.tenantId)
      })
  }

  getSubscriptionNotificationList(id :string , flag:boolean){
     this.subscriptionId =id
    this.$apiClient.doRequest('get', `${this.baseUrl}/notification_status_subscriber/${this.subscriptionId}`)
    .then((res)=>{
    this.notificationStatusListBySubscriber = res.notificationStatusListBySubscriber
    if(flag){
      this.openSideBar(flag);
    }
  })
  }

  isActive(id:string) {
    return this.subscriptionId === id;
  }

  @Watch('searchText')
  private doSearch() {
      if(this.searchText){
          this.items = this.notificationSubscriberList?.filter((item :any ) => 
          item.subscriberUserName.indexOf(this.searchText) > -1
         )
      }else {
       this.items = this.notificationSubscriberList
      }
  }
  
  sortByCompanyName(isSwitchAsc?: boolean) {
    this.sortByCompanyNameASC = isSwitchAsc ? !this.sortByCompanyNameASC : this.sortByCompanyNameASC;
    this.notificationSubscriberList.sort((a: any, b: any) => {
      const valueA = a.companyName || "";
      const valueB = b.companyName || "";
      if (valueA === "" || valueA === null) {
        return this.sortByCompanyNameASC ? 1 : -1;
      }
      if (valueB === "" || valueB === null) {
        return this.sortByCompanyNameASC ? -1 : 1;
      }
      return this.sortByCompanyNameASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
  }

  openSideBar = (flag :boolean) => {
    const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
    if (!isResponsive || !flag) {
      return; 
    }
    if(document.body.classList.contains('sideopen')){
        document.body.classList.remove('sideopen')
    }else{
        document.body.classList.add('sideopen')
    }
  }
}